import { injectPageComponentaContext } from "widgets/commonComponents/base/injectPageComponentaContext"
import { LinkedItemFieldDisplay } from "widgets/commonDataObjects/linkedItemsFieldsDisplay"
import { isWcmEditor } from "config/serverConfig"
import { SlotIconDisplay } from "widgets/commonComponents/inline/slotIconDisplay/slotIconDisplay"
import { ComponentaIconType } from "widgets/commonDataObjects/interfaces"
import { getImgAlt, isAriaHidden, getImgTitle, calculateAutomaticComponentaUrl } from "widgets/widgetsUtils"
import * as apiUrls from "config/apiUrls"
import { isHavakVisible, PayWallArctilceIcon } from "widgets/commonComponents/inline/payWallHavak/payWallHavak";
import { DateDisplay } from "widgets/commonComponents/inline/dateDisplay/dateDisplay"
import { SimpleLinkRenderer } from "../../../../commonComponents/inline/hyperLink"
import { MarketingSign } from "../../../../commonComponents/inline/marketingSign/marketingSign"
import { SiteLayoutType } from "pagesPage/stateInterfaces"
import { MutamMarketingSign } from "../../../../commonComponents/inline/marketingSign/mutamMarketingSign"
import { PageComponentaContext } from "widgets/interfaces"
import { RenderReactAtSite } from "widgets/commonComponents/inline/renderReactAtSite"

export interface GalhedAutoItemSlotProps {
    image?: any
    title: string
    roof: string
    link: string
    fallenDate: string
    fallenDetails: string
    isVer2?: boolean
}

@injectPageComponentaContext()
export class GalhedItemSlot extends React.Component<GalhedAutoItemSlotProps & Partial<PageComponentaContext>, {}> {

    public render() {
        const { image, siteLayoutType, title, roof, link, fallenDate, fallenDetails, isVer2 } = this.props

        let moreInfo;


        const isMobile = siteLayoutType === "mobileWeb";
        const imageSizes = isVer2
            ? (isMobile ? { w: 88, h: 156 } : { w: 84, h: 150 })
            : { w: 92, h: 141 };


        return (
            <SimpleLinkRenderer href={link} className={"slotView"}>
                <div className="imageArea">
                    <img src={apiUrls.getImageUrl(image, imageSizes)} width={imageSizes.w} height={imageSizes.h} alt={getImgAlt(image)} title={getImgTitle(image)} aria-hidden={isAriaHidden(image)} />
                </div>
                <div className="textArea">

                    <div className="slotRoof">
                        {roof}
                    </div>
                    <div className="slotTitle">

                        {title}

                    </div>
                    <div className="specialDetails">
                        <div className="slotFallenDate">
                            {fallenDate}
                        </div>
                        <div className="slotFallenDetails">
                            {fallenDetails}
                        </div>
                    </div>
           
                </div>



            </SimpleLinkRenderer>
        )
    }
}